export default "__VITE_ASSET__DDD5JjgP__"